import { language as lan_detailBreadcrumb } from "./breadcrumb";
import { language as lan_detailAddToCart } from "./add-to-cart";
import { language as lan_detailPrice } from "./price";
import { language as lan_detailStartDesign } from "./strat-design";
import { language as lan_detailRest } from "./detail-rest";
import { language as lan_detailSpecification } from "./specification";
import { language as lan_detailShipping } from "./shipping";
import { language as lan_detailSnapShop } from "./snap-shop";
import { language as lan_detailApiIntegration } from "./api-integration";
import { language as lan_detailRecommend } from "./recommend";
import { language as lan_designModel } from "./design-model"; 

let language = {
    ...lan_detailBreadcrumb,
    ...lan_detailAddToCart,
    ...lan_detailPrice,
    ...lan_detailStartDesign,
    ...lan_detailRest,
    ...lan_detailSpecification,
    ...lan_detailShipping,
    ...lan_detailSnapShop,
    ...lan_detailApiIntegration,
    ...lan_detailRecommend,
    ...lan_designModel,
    // 产品类型暂暂不支持-进行产品定制
    PRODUCT_DETAIL_INVALID_ORDER_A_SAMPLE_TITLE: "Invalid order a sample",
    PRODUCT_DETAIL_INVALID_ORDER_A_SAMPLE_CONTENT: "Opps! An error occurred when you are trying to open builder page, please try again later.",
    // 产品运费计算器
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE: "Product shipping calculate issue",
    PRODUCT_DETAIL_SHIPPING_ERROR_TITLE: "Shipping Price Loading Error",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT1: "An error occurred while to calculate the shipping cost of the product. Please click \"{{retryBtn}}\" to try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT2: "There was an error when calculating the shipping cost. Please refresh the page and try again. If the problem persists, contact us at {{supportmail}}.",
    PRODUCT_DETAIL_SHIPPING_CUSTOM_QTY_MIN_TIP: "The minimum product quantity is {{minQty}}.",
    PRODUCT_DETAIL_SHIPPING_CUSTOM_QTY_MAX_TIP: "The maximum  product quantity is {{maxQty}}.",
    PRODUCT_DETAIL_SHIPPING_PRRICE_NULL_TIP:"This shipping method is not available for the selected product quantity.",
    PRODUCT_DETAIL_SHIPPING_EXPORT_ISSUE_TITLE:"Product shipping export issue",
    PRODUCT_DETAIL_SHIPPING_EXPORT_ERROE_TITLE:"Product shipping export error",
    PRODUCT_DETAIL_SHIPPING_EXPORT_ISSUE_CONTENT1:"An error occurred while to export the shipping cost of the product. Please try again later. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    PRODUCT_DETAIL_PRICE_ISSUE_TITLE:"Product Price Table Issue",
    PRODUCT_DETAIL_PRICE_ISSUE_CONTENT:"An error occurred while to query the tiered price table of the product.  Please refresh the page and try again. If the problem persists, contact us at {{supportmail}}.",
    PRODUCT_DETAIL_PRICE_ERROE_TITLE:"Product Price Table Error",
    PRODUCT_DETAIL_CURRENCY_CONFIG_MISSING:"There is an error with the {{appName}} currency setting. Please refresh the page and click \"{{updateCurrencyBtn}}\" to update {{appName}} display currency. If issues still persist, please contact {{serviceEmail}}.",
    PRODUCT_DETAIL_CURRENCY_NONSUPPORT:"The currency you selected is not supported. Please click \"{{updateCurrencyBtn}}\" to update {{appName}} display currency.",
    PRODUCT_DETAIL_DESIGN_METHOD_ISSUE_TITLE:"Product design method issue",
    PRODUCT_DETAIL_DESIGN_METHOD_ISSUE_CONTENT:"An error occurred while to update the product design method. Please try again later. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    PRODUCT_DETAIL_PARTNER_TYPE_TITLE: "Partner Type Error",
    PRODUCT_DETAIL_PARTNER_TYPE_CONTENT: "Current product is internal product,access is only allowed to internal users,please go to login first",
}

export { language }